import styled from 'styled-components';

import { FeatureFlags } from 'featureFlags/constants';
import { useFeatureFlag } from 'shared/hooks/useFeatureFlag';
import { SearchSuggestions } from './SearchSuggestions';
import { LatestSearches } from './LatestSearches';
import { RecentSearches } from './RecentSearches';

const DefaultSearchView = ({ suggestedSearches, error }) => {
  const isLatestSearchesEnabled = useFeatureFlag(FeatureFlags.WEB_ENABLE_LATEST_SEARCHES);
  const isRecentSearchesEnabled = useFeatureFlag(FeatureFlags.WEB_ENABLE_RECENT_SEARCHES);
  const isSuggestedSearchesEnabled = useFeatureFlag(FeatureFlags.WEB_ENABLE_SUGGESTED_SEARCHES);

  return (
    <DefaultSearchView.Wrapper>
      {isSuggestedSearchesEnabled && (
        <SearchSuggestions suggestedSearches={suggestedSearches} error={error} />
      )}
      {isLatestSearchesEnabled && <LatestSearches />}
      {isRecentSearchesEnabled && <RecentSearches />}
    </DefaultSearchView.Wrapper>
  );
};

DefaultSearchView.Wrapper = styled.div`
  padding: 16px;
`;

export default DefaultSearchView;
